const ReactBeamer = {
  initialize: (product_id) =>
    new Promise((resolve) => {
      window.beamer_config = {
        product_id,
      };
      ((d, s, v, c, e, y) => {
        ((e = d.createElement(s)), (y = d.getElementsByTagName(s)[0]));
        e.async = 1;
        e.src = v;
        if (c) {
          e.addEventListener(
            "load",
            (e) => {
              c(null, e);
            },
            false,
          );
        }
        y.parentNode.insertBefore(e, y);
      })(
        document,
        "script",
        "https://app.getbeamer.com/js/beamer-embed.js",
        () => {
          resolve();
        },
      );
    }),
};

export default ReactBeamer;
